import type { FirebaseOptions } from 'firebase/app';

export function getFirebaseWebConfig(): FirebaseOptions | null {
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
  const appId = process.env.REACT_APP_FIREBASE_APP_ID;

  if (!apiKey || !authDomain || !projectId || !messagingSenderId || !appId) {
    return null;
  }

  return {
    apiKey,
    authDomain,
    projectId,
    storageBucket: storageBucket ?? undefined,
    messagingSenderId,
    appId,
  };
}

export function getFirebaseVapidKey(): string | null {
  const key = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  return key?.trim() ? key : null;
}
